import React from 'react';
import {
  ActionsWrapper,
  Card,
  CopyItem,
  CopyLinkWrapper,
  CopyTitle,
  CopyValue,
  CopyWrapper,
  // GoogleText,
  // GoogleWrapper,
} from '../styles';
import { successToast } from 'lib/components/toasts/success';
import { checkAttendeeLimit } from 'lib/utils/productFeature';
import { useAuth } from 'lib/context';
import { Button } from 'react-covideo-common';
import { useCurrentAppUrl } from 'lib/hooks/useCurrentAppUrl';
import { useGTMAnalytics } from 'lib/hooks/GTM/useGTMAnalytics';
import { MeetingResponse } from 'lib/api/meetings/types';
import { GTMMeetingInteractionAction } from 'lib/hooks/GTM/actions/meeting/types';
import { useTranslation } from 'react-i18next';
interface MeetingInfoBannerProps {
  meetingDetails: MeetingResponse | undefined;
}

const MeetingInfoBanner = ({ meetingDetails }: MeetingInfoBannerProps) => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const attendeeLimit = checkAttendeeLimit(userData);
  const { meetingId } = meetingDetails || {};
  const { livePageUrl } = useCurrentAppUrl();
  const { trackGTMMeetingInteractionEvent } = useGTMAnalytics();

  // const [googleCalendar, setGoogleCalendar] = useState<boolean>(false);
  const liveLink = meetingId ? livePageUrl + meetingId : '';

  const copyToClipboard = (copy: string | null, type: 'URL' | 'Meeting ID') => {
    const cb = navigator.clipboard;
    if (copy)
      cb.writeText(copy).then(() => {
        successToast({ title: t('{{type}} copied successfully!', { type }) });
      });
    if (meetingDetails) {
      trackGTMMeetingInteractionEvent?.({
        attendeeLimit,
        livePageUrl,
        meetingResponse: meetingDetails,
        action: GTMMeetingInteractionAction.COPY_DETAILS,
      });
    }
  };

  return (
    <Card>
      <ActionsWrapper>
        {/* <GoogleWrapper>
          <GoogleText>Add to Google Calendar</GoogleText>
          <Switch
            id={'add-to-google-calendar'}
            isOn={googleCalendar}
            onColor={theme.palette.covideoOrange100}
            handleToggle={() => setGoogleCalendar(!googleCalendar)}
          />
        </GoogleWrapper> */}
        <CopyWrapper>
          {meetingId && (
            <>
              <CopyItem>
                <CopyTitle>{t('Meeting ID')}</CopyTitle>
                <CopyLinkWrapper>
                  <CopyValue>{meetingId}</CopyValue>
                  <Button
                    text={t('Copy')}
                    onClick={() => {
                      copyToClipboard(meetingId, 'Meeting ID');
                    }}
                    variant='white'
                    size='small'
                  />
                </CopyLinkWrapper>
              </CopyItem>
              <CopyItem>
                <CopyTitle>{t('URL to Join')}</CopyTitle>
                <CopyLinkWrapper>
                  <CopyValue>{liveLink}</CopyValue>
                  <Button
                    text={t('Copy')}
                    onClick={() => {
                      copyToClipboard(liveLink, 'URL');
                    }}
                    variant='white'
                    size='small'
                  />
                </CopyLinkWrapper>
              </CopyItem>
            </>
          )}
          <CopyItem>
            <CopyTitle>{t('Participants Allowed')}</CopyTitle>
            {attendeeLimit}
          </CopyItem>
        </CopyWrapper>
      </ActionsWrapper>
    </Card>
  );
};

export default MeetingInfoBanner;
